import InfoIcon from "@material-ui/icons/Info";
import { Popover } from "@material-ui/core";
import theme from "../../settings/themeConfig";

export default function MeditocPopover(props) {
    const { open, setopen, children } = props;

    const handleClose = () => {
        setopen(false);
    };

    return (
        <Popover
            anchorReference="anchorPosition"
            anchorPosition={{ top: 140, left: 20 }}
            anchorOrigin={{
                vertical: "top",
                horizontal: "left",
            }}
            transformOrigin={{
                vertical: "top",
                horizontal: "left",
            }}
            open={open}
            onClose={handleClose}
        >
            <div style={{ padding: 30, textAlign: "center" }}>
                <div>
                    <InfoIcon style={{ fontSize: 80, color: theme.palette.primary.main }} />
                </div>
                <div>{children}</div>
            </div>
        </Popover>
    );
}
